import { StyleSheet } from 'react-native';
import { useState } from 'react';
import { Button, theme } from '@socrait/react';

import { createLogger } from '~/utils/logging';

import { CopyText } from './AccordionTypes';

const log = createLogger('CopyButton');

const COPY_TEXT_TIMEOUT_MS = 2000;

interface CopyButtonProps {
  text: string | CopyText;
  containerStyle?: object;
}

export const CopyButton = ({ text, containerStyle }: CopyButtonProps) => {
  const [isCopied, setIsCopied] = useState(false);

  const handleCopy = async () => {
    if (!text) return;

    try {
      if (typeof text === 'string') {
        await navigator.clipboard.writeText(text);
        log.debug('Text copied successfully 🚀🚀');
      } else {
        if (navigator.clipboard.write) {
          const clipboardItem = new ClipboardItem({
            'text/html': new Blob([text.html], { type: 'text/html' }),
            'text/plain': new Blob([text.plain], { type: 'text/plain' }),
          });
          await navigator.clipboard.write([clipboardItem]);
          log.debug('Rich text copied successfully 🚀🚀');
        } else {
          await navigator.clipboard.writeText(text.plain);
          log.debug('Plain text copied as fallback 🚀🚀');
        }
      }

      setIsCopied(true);
      setTimeout(() => setIsCopied(false), COPY_TEXT_TIMEOUT_MS);
    } catch (err) {
      log.error('Failed to copy text:', err);
      if (typeof text !== 'string') {
        try {
          await navigator.clipboard.writeText(text.plain);
          log.debug('Plain text copied as fallback 🚀🚀');

          setIsCopied(true);
          setTimeout(() => setIsCopied(false), COPY_TEXT_TIMEOUT_MS);
        } catch (fallbackErr) {
          log.error('Fallback copy also failed:', fallbackErr);
        }
      }
    }
  };

  return (
    <Button
      name={isCopied ? 'Copied!' : 'Copy'}
      onPress={handleCopy}
      containerStyle={[styles.copyButton, containerStyle]}
      fontStyle={styles.copyButtonText}
      icon={'copy'}
      iconIsSolid={isCopied}
    />
  );
};

const styles = StyleSheet.create({
  copyButton: {
    display: 'flex',
  },
  copyButtonText: {
    fontSize: theme.fontSizes.small,
    fontFamily: theme.fonts.medium,
    fontWeight: theme.fontWeights.bold,
  },
});
